export default {"src":"/_next/static/media/metamask-fox.1ed32c74.svg","height":33,"width":35};